import Tooltip from '@/UIComponents2/Tooltip'
import { cn } from '@/utlis/cn'

export function ErrorIndicator({ text, onClick }: { text: string; onClick: () => void }) {
    return (
        <Tooltip text={text} variant="error">
            <div
                className={cn(
                    'w-[32px] min-w-[32px] h-[20px] flex rounded-4xl text-[10px] font-bold items-center justify-center bg-red-500/75 cursor-pointer'
                )}
                onClick={onClick}
            >
                ERR
            </div>
        </Tooltip>
    )
}
